import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";


const categories = [
  "Action",
  "Adventure",
  "Arcade",
  "Board",
  "Casino",
  "Casual",
  "Puzzle",
  "Racing",
  "Sports",
  "Strategy"
]

const fetchGames = async ({ pageParam = 1, categories = [] }) => {
  const categoryParam = categories.length > 0 
    ? `&category=${categories.join(",")}` 
    : "";
  const { data } = await axios.get(
    `https://be-staging.obigin.com/content/games?type=web&page=${pageParam}${categoryParam}`
  );
  return {
    games: data.data.data,
    nextPage: data.data.nextPage || null,
  };
};

function UpcomingGames() {
  const [selectedCategories, setSelectedCategories] = useState([]);

  const PrevArrow = ({ className, style, onClick }) => (
    <button
      type="button"
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        left: "6px",
        transform: "translateY(-50%)",
        zIndex: 3,
        width: "36px",
        height: "36px",
        padding: 0,
        borderRadius: "50%",
        border: "1px solid #FF1919",
        background: "#ffffff",
        color: "#FF1919",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        cursor: "pointer",
        fontSize: "0px",
      }}
      onClick={onClick}
      aria-label="Previous categories"
    >
      <span aria-hidden="true" style={{ fontSize: "20px", lineHeight: 1 }}>
        {"<"}
      </span>
    </button>
  );

  const NextArrow = ({ className, style, onClick }) => (
    <button
      type="button"
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        right: "-40px",
        transform: "translateY(-50%)",
        zIndex: 3,
        width: "36px",
        height: "36px",
        padding: 0,
        borderRadius: "50%",
        border: "1px solid #FF1919",
        background: "#ffffff",
        color: "#FF1919",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        cursor: "pointer",
        fontSize: "0px",
      }}
      onClick={onClick}
      aria-label="Next categories"
    >
      <span aria-hidden="true" style={{ fontSize: "20px", lineHeight: 1 }}>
        {">"}
      </span>
    </button>
  );

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isError,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ["games", selectedCategories],
    queryFn: ({ pageParam = 1 }) => fetchGames({ pageParam, categories: selectedCategories }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
  });

  const toggleCategory = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  const allGames = data?.pages.flatMap((page) => page.games) || [];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    autoplay: selectedCategories.length === 0,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <section className="upcoming-games-area upcoming-games-bg pb-80 pt-40">
      <div className="container">
        {/* Category Filter */}
        <div className="row mb-5">
          <div className="col-11 mx-auto px-4">
            <div 
              className="category-filter-section" 
            >
              {selectedCategories.length > 0 && (
                <button
                  type="button"
                  onClick={() => setSelectedCategories([])}
                >
                  Clear
                </button>
              )}
              
              <div 
                className="category-slider-wrapper"
                style={{
                  padding: "10px 0px",
                  position: "relative",
                  backgroundColor: "#FF1919",
                }}
              >
                <Slider   {...sliderSettings}>
                  {categories.map((category) => {
                    const isSelected = selectedCategories.includes(category);
                    return (
                      <div style={{padding:"8px"}} key={category}>
                        <button
                          onClick={() => toggleCategory(category)}
                          style={{ 
                            width: "calc(100% - 40px)",
                            margin: "0 10px",
                            padding: "10px 16px",
                            fontSize: "13px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            border: "none",
                            borderRadius: "8px",
                            textWrap: "nowrap",
                            background: "#ffffff",
                            color:  "#000",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            boxShadow: isSelected
                              ? "0 4px 15px rgba(255, 25, 25, 0.4)"
                              : "0 2px 8px rgba(0, 0, 0, 0.1)",
                            position: "relative",
                            overflow: "hidden"
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.target.style.transform = "translateY(-2px)";
                              e.target.style.boxShadow = "0 4px 12px rgba(255, 25, 25, 0.3)";
                            } else {
                              e.target.style.transform = "translateY(-2px)";
                              e.target.style.boxShadow = "0 6px 20px rgba(255, 25, 25, 0.6)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.target.style.transform = "translateY(0)";
                              e.target.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
                            } else {
                              e.target.style.transform = "translateY(0)";
                              e.target.style.boxShadow = "0 4px 15px rgba(255, 25, 25, 0.4)";
                            }
                          }}
                        >
                          {isSelected && (
                            <i className="fas fa-check-circle" style={{ 
                              marginRight: "6px",
                              fontSize: "12px"
                            }}></i>
                          )}
                          {category}
                        </button>
                      </div>
                    );
                  })}
                </Slider>
                  
              </div>
            </div>
          </div>
        </div>

        {(isLoading && !data) && <p>Loading games...</p>}
        {(isError && !data) && <p>Failed to load games</p>}

        <div className="row">
          {allGames.map((game) => (
            <div className="col-lg-4 col-md-6 mb-4" key={game._id}>
              <Link to={`/details/${game._id}`}>
                <div className="upcoming-game-item">
                  <div className="upcoming-game-head">
                    <div className="uc-game-head-title">
                      <h1 className="text-red">{game.name}</h1>
                      <h4>
                        <a
                          href={game.link || "#"}
                          target="_blank"
                          rel="noreferrer"
                        >
                        {game.genre?.length > 0 ? game.genre.join(", ") : "N/A"}
                        </a>
                      </h4>
                    </div>
                  </div>
                  <p
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {game.shortDescription || "No description available."}
                  </p>
                  <div className="upcoming-game-thumb">
                    <img
                      src={
                        game.graphic || "assets/img/images/default_thumb.jpg"
                      }
                      alt={game.name}
                      style={{ width: "100%", height: "200px",objectFit:"cover" }}
                    />
                    <div className="upcoming-game-cart">
                      <a
                        href={game.link || "#"}
                        className="btn transparent-btn"
                      >
                        <i className="fas fa-shopping-basket" />
                        {game.status === "live"
                          ? "View Details"
                          : "COMING SOON"}
                      </a>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {hasNextPage && (
          <div className="text-center mt-4">
            <button
              className="btn btn-style-two"
              onClick={() => fetchNextPage()}
              disabled={isFetchingNextPage}
            >
              {isFetchingNextPage ? "Loading..." : "Load More"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default UpcomingGames;
